import { Library } from "./library";
import { Permission } from "./permission";
import { Handler } from "./handler";
import { MinimalLibrary } from "./minimal-library";

export class User {
  public constructor(
    public username?: string,
    public password?: string,
    public library?: Library,
    public email?: string,
    public id?: number,
    public permissions?: Permission[],
    public requestPasswordReset?: boolean,
    public rosterNotificationMailSchedule: number = -1,
    public otpEnabled: boolean = false
  ) {}

  public static clone(user: User): User {
    return new User(
      user.username,
      user.password,
      user.library,
      user.email,
      user.id,
      user.permissions,
      user.requestPasswordReset,
      user.rosterNotificationMailSchedule,
      user.otpEnabled
    );
  }

  // removed backend db structure
}






















